import React from 'react';
import clsx from 'clsx';
import { ButtonLoading } from './ButtonLoading';
import { WhisperComponent } from './developers/page-components/WhisperComponent';
import { TypeAttributes } from 'rsuite/cjs/internals/types';
import './ButtonComponent.scss';

export enum BUTTON_TYPE {
	TRANSPARENT = 'transparent',
	WHITE = 'white',
	CANCELLED = 'cancelled',
	DEFAULT_BLACK = 'default-black',
	FAKE_LINK = 'link',
	WHITE_SUCCESS = 'white-success',
	WHITE_PRIMARY = 'white-primary',
}

interface Props {
	buttonType?: BUTTON_TYPE;
	onButtonClick?: () => void;
	isDisabled?: boolean;
	loading?: boolean;
	buttonName?: string;
	additionalClass?: string;
	type?: 'button' | 'submit' | 'reset';
	children?: React.ReactElement;
	withoutUnderline?: boolean;
	isTooltip?: boolean;
	tooltipText?: string;
	tooltipPlacement?: TypeAttributes.Placement;
	cypressAttribute?: string;
	icon?: React.ReactElement;
}
export const ButtonComponent = (props: Props): React.ReactElement => {
	const {
		buttonType, onButtonClick,
		isDisabled, buttonName,
		loading, additionalClass,
		children, type,
		withoutUnderline, isTooltip,
		tooltipText, tooltipPlacement,
		cypressAttribute = 'button-component',
		icon
	} = props;

	const getButtonStyles = (): string => {
		switch (buttonType) {
			case BUTTON_TYPE.TRANSPARENT: {
				return 'btn-sm btn-hover-danger btn-color-danger';
			}
			case BUTTON_TYPE.WHITE: {
				return 'btn-sm btn-outline btn-outline-danger';
			}
			case BUTTON_TYPE.CANCELLED: {
				return 'btn-outline-danger';
			}
			case BUTTON_TYPE.DEFAULT_BLACK: {
				return 'btn-primary-black';
			}
			case BUTTON_TYPE.WHITE_SUCCESS: {
				return 'btn-outline-pmr';
			}
			case BUTTON_TYPE.WHITE_PRIMARY: {
				return 'btn-sm btn-outline-primary';
			}
			case BUTTON_TYPE.FAKE_LINK: {
				const baseClass = 'btn-link text-danger';
				return withoutUnderline ? baseClass : `${baseClass} text-decoration-underline`;
			}
			default: {
				return 'btn-danger';
			}
		}

	};


	const mainButton = (
		<button
			type={type ? type : 'button'}
			className={clsx(
				'btn fw-bolder letter-spacing',
				isDisabled && 'cursor-not-allowed',
				getButtonStyles(), additionalClass)}
			onClick={onButtonClick}
			disabled={isDisabled}
			data-cy={cypressAttribute}
		>
			{
				loading
					? <ButtonLoading/>
					: (
						<>
							{icon && icon}
							{buttonName || children}
						</>
					)
			}
		</button>
	);
	return (
		<>
			{
				isTooltip
					? (
						<WhisperComponent
							isTooltip
							whisperText={tooltipText}
							placement={tooltipPlacement}
							mainText={mainButton}
						/>
					)
					: mainButton
			}
		</>
	);
};

